import React from 'react';

const QualificationsTitle = () => {
    return (
        <section className="qualifications-title">
            <div className="container">
                <div className="qualifications-title__title-box">
                    <h1 className="qualifications-title__title">Moje kwalifikacje</h1>
                    <div className="qualifications-title__title-hr"></div>
                </div>
            </div>
        </section>
    );
}

export default QualificationsTitle;